(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6a95"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6a95"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7blyj", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $53aa475b3dff15cd$export$6503ec6e8aabbaf; }, function (v) { return $53aa475b3dff15cd$export$6503ec6e8aabbaf = v; });
var $53aa475b3dff15cd$export$6503ec6e8aabbaf;
var $53aa475b3dff15cd$export$f7ad0328861e2f03;
"use strict";
var $53aa475b3dff15cd$var$mapping = new Map();
function $53aa475b3dff15cd$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$53aa475b3dff15cd$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $53aa475b3dff15cd$var$resolve(id) {
    var resolved = $53aa475b3dff15cd$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$53aa475b3dff15cd$export$6503ec6e8aabbaf = $53aa475b3dff15cd$var$register;
$53aa475b3dff15cd$export$f7ad0328861e2f03 = $53aa475b3dff15cd$var$resolve;

});

parcelRegister("74lVz", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $5259ea78375d8d75$export$bdfd709ae4826697; }, function (v) { return $5259ea78375d8d75$export$bdfd709ae4826697 = v; });
var $5259ea78375d8d75$export$bdfd709ae4826697;
var $5259ea78375d8d75$export$c9e73fbda7da57b6;
var $5259ea78375d8d75$export$5a759dc7a1cfb72a;
"use strict";
var $5259ea78375d8d75$var$bundleURL = {};
function $5259ea78375d8d75$var$getBundleURLCached(id) {
    var value = $5259ea78375d8d75$var$bundleURL[id];
    if (!value) {
        value = $5259ea78375d8d75$var$getBundleURL();
        $5259ea78375d8d75$var$bundleURL[id] = value;
    }
    return value;
}
function $5259ea78375d8d75$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $5259ea78375d8d75$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $5259ea78375d8d75$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $5259ea78375d8d75$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$5259ea78375d8d75$export$bdfd709ae4826697 = $5259ea78375d8d75$var$getBundleURLCached;
$5259ea78375d8d75$export$c9e73fbda7da57b6 = $5259ea78375d8d75$var$getBaseURL;
$5259ea78375d8d75$export$5a759dc7a1cfb72a = $5259ea78375d8d75$var$getOrigin;

});

var $9343d5cdb7b2821e$exports = {};


(parcelRequire("7blyj")).register((parcelRequire("74lVz")).getBundleURL("7EiNB"), JSON.parse('["7EiNB","index.ba439fa8.js","hIS1S","bg.b30656cf.mov","iLtLE","bg.5ea1a05b.webm"]'));

function $3015b282b063971c$var$isFirefox() {
    const ua = window.navigator.userAgent.toLowerCase();
    return ua.indexOf("firefox") !== -1;
}
function $3015b282b063971c$var$isSafari() {
    const ua = window.navigator.userAgent.toLowerCase();
    return ua.indexOf("safari") !== -1 && !(ua.indexOf("chrome") !== -1) && ua.indexOf("version/") !== -1;
}
function $3015b282b063971c$var$supportsHEVCAlpha() {
    if ($3015b282b063971c$var$isFirefox()) return false;
    if ($3015b282b063971c$var$isSafari()) {
        const hasMediaCapabilities = window.navigator.mediaCapabilities && window.navigator.mediaCapabilities.decodingInfo;
        return hasMediaCapabilities;
    }
    return true;
}
var $8b2cc4ee2e264d5a$exports = {};

$8b2cc4ee2e264d5a$exports = (parcelRequire("74lVz")).getBundleURL("7EiNB") + "bg.b30656cf.mov";


var $9ad91bf6b6f6c8fe$exports = {};

$9ad91bf6b6f6c8fe$exports = (parcelRequire("74lVz")).getBundleURL("7EiNB") + "bg.5ea1a05b.webm";


function $3015b282b063971c$var$main() {
    const player = document.getElementById("player");
    player.src = $3015b282b063971c$var$supportsHEVCAlpha() ? new URL($8b2cc4ee2e264d5a$exports) : new URL($9ad91bf6b6f6c8fe$exports);
}
window.addEventListener("DOMContentLoaded", ()=>$3015b282b063971c$var$main());

})();
//# sourceMappingURL=index.ba439fa8.js.map
